/* eslint-disable jsx-a11y/no-static-element-interactions */

import PropTypes from 'prop-types';
import React from 'react';
import ZIStyles from './ZIStyles.scss';

const ZipsInput = ({ value, removeZipCode }) => (<div className={ZIStyles.tag}>
  <div>{value}</div>
  <div
    className={ZIStyles.remove}
    onClick={() => removeZipCode(value)}
  >x</div>
</div>);

ZipsInput.propTypes = {
  value: PropTypes.string,
  removeZipCode: PropTypes.func,
};

ZipsInput.defaultProps = { value: '' };

export default ZipsInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/TaggedInput/CustomTaggedInput/ZipsInput/ZIIndex.jsx